/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AyrshareSSOResponse } from "../../models/ayrshareSSOResponse";

import type { BodyPostV1ExchangeOauthCodeForTokens } from "../../models/bodyPostV1ExchangeOauthCodeForTokens";

import type { CredentialsMetaResponse } from "../../models/credentialsMetaResponse";

import type { DeleteV1DeleteCredentials200 } from "../../models/deleteV1DeleteCredentials200";

import type { DeleteV1DeleteCredentialsParams } from "../../models/deleteV1DeleteCredentialsParams";

import type { GetV1InitiateOauthFlowParams } from "../../models/getV1InitiateOauthFlowParams";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse";

import type { HTTPValidationError } from "../../models/hTTPValidationError";

import type { LoginResponse } from "../../models/loginResponse";

import type { PickerTokenResponse } from "../../models/pickerTokenResponse";

import type { PostV1CreateCredentialsBody } from "../../models/postV1CreateCredentialsBody";

import type { ProviderConstants } from "../../models/providerConstants";

import type { ProviderEnumResponse } from "../../models/providerEnumResponse";

import type { ProviderMetadata } from "../../models/providerMetadata";

import type { ProviderNamesResponse } from "../../models/providerNamesResponse";

import { customMutator } from "../../../mutators/custom-mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Generate a JWT SSO URL so the user can link their social accounts.

The per-user Ayrshare profile key is provisioned and persisted as a
standard ``is_managed=True`` credential by
:class:`~backend.integrations.managed_providers.ayrshare.AyrshareManagedProvider`.
This endpoint only signs a short-lived JWT pointing at the Ayrshare-
hosted social-linking page; all profile lifecycle logic lives with the
managed provider.
 * @summary Get Ayrshare Sso Url
 */
export type getV1GetAyrshareSsoUrlResponse200 = {
  data: AyrshareSSOResponse;
  status: 200;
};

export type getV1GetAyrshareSsoUrlResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetAyrshareSsoUrlResponseSuccess =
  getV1GetAyrshareSsoUrlResponse200 & {
    headers: Headers;
  };
export type getV1GetAyrshareSsoUrlResponseError =
  getV1GetAyrshareSsoUrlResponse401 & {
    headers: Headers;
  };

export type getV1GetAyrshareSsoUrlResponse =
  | getV1GetAyrshareSsoUrlResponseSuccess
  | getV1GetAyrshareSsoUrlResponseError;

export const getGetV1GetAyrshareSsoUrlUrl = () => {
  return `/api/integrations/ayrshare/sso_url`;
};

export const getV1GetAyrshareSsoUrl = async (
  options?: RequestInit,
): Promise<getV1GetAyrshareSsoUrlResponse> => {
  return customMutator<getV1GetAyrshareSsoUrlResponse>(
    getGetV1GetAyrshareSsoUrlUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetAyrshareSsoUrlQueryKey = () => {
  return [`/api/integrations/ayrshare/sso_url`] as const;
};

export const getGetV1GetAyrshareSsoUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetAyrshareSsoUrlQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>
  > = ({ signal }) => getV1GetAyrshareSsoUrl({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetAyrshareSsoUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>
>;
export type GetV1GetAyrshareSsoUrlQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1GetAyrshareSsoUrl<
  TData = Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
          TError,
          Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetAyrshareSsoUrl<
  TData = Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
          TError,
          Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetAyrshareSsoUrl<
  TData = Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Ayrshare Sso Url
 */

export function useGetV1GetAyrshareSsoUrl<
  TData = Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetAyrshareSsoUrlQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Ayrshare Sso Url
 */
export const prefetchGetV1GetAyrshareSsoUrlQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAyrshareSsoUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetAyrshareSsoUrlQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Credentials
 */
export type getV1ListCredentialsResponse200 = {
  data: CredentialsMetaResponse[];
  status: 200;
};

export type getV1ListCredentialsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListCredentialsResponseSuccess =
  getV1ListCredentialsResponse200 & {
    headers: Headers;
  };
export type getV1ListCredentialsResponseError =
  getV1ListCredentialsResponse401 & {
    headers: Headers;
  };

export type getV1ListCredentialsResponse =
  | getV1ListCredentialsResponseSuccess
  | getV1ListCredentialsResponseError;

export const getGetV1ListCredentialsUrl = () => {
  return `/api/integrations/credentials`;
};

export const getV1ListCredentials = async (
  options?: RequestInit,
): Promise<getV1ListCredentialsResponse> => {
  return customMutator<getV1ListCredentialsResponse>(
    getGetV1ListCredentialsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListCredentialsQueryKey = () => {
  return [`/api/integrations/credentials`] as const;
};

export const getGetV1ListCredentialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ListCredentials>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1ListCredentialsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListCredentials>>
  > = ({ signal }) => getV1ListCredentials({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListCredentials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListCredentialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListCredentials>>
>;
export type GetV1ListCredentialsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1ListCredentials<
  TData = Awaited<ReturnType<typeof getV1ListCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListCredentials>>,
          TError,
          Awaited<ReturnType<typeof getV1ListCredentials>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListCredentials<
  TData = Awaited<ReturnType<typeof getV1ListCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListCredentials>>,
          TError,
          Awaited<ReturnType<typeof getV1ListCredentials>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListCredentials<
  TData = Awaited<ReturnType<typeof getV1ListCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Credentials
 */

export function useGetV1ListCredentials<
  TData = Awaited<ReturnType<typeof getV1ListCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListCredentialsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Credentials
 */
export const prefetchGetV1ListCredentialsQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListCredentialsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * Get metadata for every available provider.

Returns both statically defined providers (from ``ProviderName`` enum) and
dynamically registered providers (from SDK decorators). Each entry includes
a ``description`` declared via ``ProviderBuilder.with_description(...)`` in
the provider's ``_config.py``.

Note: The complete list of provider names is also available as a constant
in the generated TypeScript client via PROVIDER_NAMES.
 * @summary List Providers
 */
export type getV1ListProvidersResponse200 = {
  data: ProviderMetadata[];
  status: 200;
};

export type getV1ListProvidersResponseSuccess =
  getV1ListProvidersResponse200 & {
    headers: Headers;
  };
export type getV1ListProvidersResponse = getV1ListProvidersResponseSuccess;

export const getGetV1ListProvidersUrl = () => {
  return `/api/integrations/providers`;
};

export const getV1ListProviders = async (
  options?: RequestInit,
): Promise<getV1ListProvidersResponse> => {
  return customMutator<getV1ListProvidersResponse>(getGetV1ListProvidersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetV1ListProvidersQueryKey = () => {
  return [`/api/integrations/providers`] as const;
};

export const getGetV1ListProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListProviders>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ListProviders>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1ListProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListProviders>>
  > = ({ signal }) => getV1ListProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListProviders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListProviders>>
>;
export type GetV1ListProvidersQueryError = unknown;

export function useGetV1ListProviders<
  TData = Awaited<ReturnType<typeof getV1ListProviders>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListProviders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListProviders>>,
          TError,
          Awaited<ReturnType<typeof getV1ListProviders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListProviders<
  TData = Awaited<ReturnType<typeof getV1ListProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListProviders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListProviders>>,
          TError,
          Awaited<ReturnType<typeof getV1ListProviders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListProviders<
  TData = Awaited<ReturnType<typeof getV1ListProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListProviders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Providers
 */

export function useGetV1ListProviders<
  TData = Awaited<ReturnType<typeof getV1ListProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListProviders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListProvidersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Providers
 */
export const prefetchGetV1ListProvidersQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListProviders>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListProviders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListProvidersQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * Get provider names as constants.

This endpoint returns a model with provider names as constants,
specifically designed for OpenAPI code generation tools to create
TypeScript constants.
 * @summary Get Provider Constants
 */
export type getV1GetProviderConstantsResponse200 = {
  data: ProviderConstants;
  status: 200;
};

export type getV1GetProviderConstantsResponseSuccess =
  getV1GetProviderConstantsResponse200 & {
    headers: Headers;
  };
export type getV1GetProviderConstantsResponse =
  getV1GetProviderConstantsResponseSuccess;

export const getGetV1GetProviderConstantsUrl = () => {
  return `/api/integrations/providers/constants`;
};

export const getV1GetProviderConstants = async (
  options?: RequestInit,
): Promise<getV1GetProviderConstantsResponse> => {
  return customMutator<getV1GetProviderConstantsResponse>(
    getGetV1GetProviderConstantsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetProviderConstantsQueryKey = () => {
  return [`/api/integrations/providers/constants`] as const;
};

export const getGetV1GetProviderConstantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetProviderConstants>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetProviderConstants>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetProviderConstantsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetProviderConstants>>
  > = ({ signal }) => getV1GetProviderConstants({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetProviderConstants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetProviderConstantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetProviderConstants>>
>;
export type GetV1GetProviderConstantsQueryError = unknown;

export function useGetV1GetProviderConstants<
  TData = Awaited<ReturnType<typeof getV1GetProviderConstants>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderConstants>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetProviderConstants>>,
          TError,
          Awaited<ReturnType<typeof getV1GetProviderConstants>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetProviderConstants<
  TData = Awaited<ReturnType<typeof getV1GetProviderConstants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderConstants>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetProviderConstants>>,
          TError,
          Awaited<ReturnType<typeof getV1GetProviderConstants>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetProviderConstants<
  TData = Awaited<ReturnType<typeof getV1GetProviderConstants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderConstants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Provider Constants
 */

export function useGetV1GetProviderConstants<
  TData = Awaited<ReturnType<typeof getV1GetProviderConstants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderConstants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetProviderConstantsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Provider Constants
 */
export const prefetchGetV1GetProviderConstantsQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetProviderConstants>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderConstants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetProviderConstantsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * Example endpoint that uses the CompleteProviderNames enum.

This endpoint exists to ensure that the CompleteProviderNames enum is included
in the OpenAPI schema, which will cause Orval to generate it as a
TypeScript enum/constant.
 * @summary Get Provider Enum Example
 */
export type getV1GetProviderEnumExampleResponse200 = {
  data: ProviderEnumResponse;
  status: 200;
};

export type getV1GetProviderEnumExampleResponseSuccess =
  getV1GetProviderEnumExampleResponse200 & {
    headers: Headers;
  };
export type getV1GetProviderEnumExampleResponse =
  getV1GetProviderEnumExampleResponseSuccess;

export const getGetV1GetProviderEnumExampleUrl = () => {
  return `/api/integrations/providers/enum-example`;
};

export const getV1GetProviderEnumExample = async (
  options?: RequestInit,
): Promise<getV1GetProviderEnumExampleResponse> => {
  return customMutator<getV1GetProviderEnumExampleResponse>(
    getGetV1GetProviderEnumExampleUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetProviderEnumExampleQueryKey = () => {
  return [`/api/integrations/providers/enum-example`] as const;
};

export const getGetV1GetProviderEnumExampleQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetProviderEnumExampleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetProviderEnumExample>>
  > = ({ signal }) =>
    getV1GetProviderEnumExample({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetProviderEnumExampleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetProviderEnumExample>>
>;
export type GetV1GetProviderEnumExampleQueryError = unknown;

export function useGetV1GetProviderEnumExample<
  TData = Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
          TError,
          Awaited<ReturnType<typeof getV1GetProviderEnumExample>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetProviderEnumExample<
  TData = Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
          TError,
          Awaited<ReturnType<typeof getV1GetProviderEnumExample>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetProviderEnumExample<
  TData = Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Provider Enum Example
 */

export function useGetV1GetProviderEnumExample<
  TData = Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetProviderEnumExampleQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Provider Enum Example
 */
export const prefetchGetV1GetProviderEnumExampleQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderEnumExample>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetProviderEnumExampleQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * Get all provider names in a structured format.

This endpoint is specifically designed to expose the provider names
in the OpenAPI schema so that code generators like Orval can create
appropriate TypeScript constants.
 * @summary Get Provider Names
 */
export type getV1GetProviderNamesResponse200 = {
  data: ProviderNamesResponse;
  status: 200;
};

export type getV1GetProviderNamesResponseSuccess =
  getV1GetProviderNamesResponse200 & {
    headers: Headers;
  };
export type getV1GetProviderNamesResponse =
  getV1GetProviderNamesResponseSuccess;

export const getGetV1GetProviderNamesUrl = () => {
  return `/api/integrations/providers/names`;
};

export const getV1GetProviderNames = async (
  options?: RequestInit,
): Promise<getV1GetProviderNamesResponse> => {
  return customMutator<getV1GetProviderNamesResponse>(
    getGetV1GetProviderNamesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetProviderNamesQueryKey = () => {
  return [`/api/integrations/providers/names`] as const;
};

export const getGetV1GetProviderNamesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetProviderNames>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetProviderNames>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1GetProviderNamesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetProviderNames>>
  > = ({ signal }) => getV1GetProviderNames({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetProviderNames>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetProviderNamesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetProviderNames>>
>;
export type GetV1GetProviderNamesQueryError = unknown;

export function useGetV1GetProviderNames<
  TData = Awaited<ReturnType<typeof getV1GetProviderNames>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderNames>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetProviderNames>>,
          TError,
          Awaited<ReturnType<typeof getV1GetProviderNames>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetProviderNames<
  TData = Awaited<ReturnType<typeof getV1GetProviderNames>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderNames>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetProviderNames>>,
          TError,
          Awaited<ReturnType<typeof getV1GetProviderNames>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetProviderNames<
  TData = Awaited<ReturnType<typeof getV1GetProviderNames>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderNames>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Provider Names
 */

export function useGetV1GetProviderNames<
  TData = Awaited<ReturnType<typeof getV1GetProviderNames>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderNames>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetProviderNamesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Provider Names
 */
export const prefetchGetV1GetProviderNamesQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetProviderNames>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetProviderNames>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetProviderNamesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * Get a list of providers that have platform credits (system credentials) available.

These providers can be used without the user providing their own API keys.
 * @summary List System Providers
 */
export type getV1ListSystemProvidersResponse200 = {
  data: string[];
  status: 200;
};

export type getV1ListSystemProvidersResponseSuccess =
  getV1ListSystemProvidersResponse200 & {
    headers: Headers;
  };
export type getV1ListSystemProvidersResponse =
  getV1ListSystemProvidersResponseSuccess;

export const getGetV1ListSystemProvidersUrl = () => {
  return `/api/integrations/providers/system`;
};

export const getV1ListSystemProviders = async (
  options?: RequestInit,
): Promise<getV1ListSystemProvidersResponse> => {
  return customMutator<getV1ListSystemProvidersResponse>(
    getGetV1ListSystemProvidersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListSystemProvidersQueryKey = () => {
  return [`/api/integrations/providers/system`] as const;
};

export const getGetV1ListSystemProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListSystemProviders>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ListSystemProviders>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ListSystemProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListSystemProviders>>
  > = ({ signal }) => getV1ListSystemProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListSystemProviders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListSystemProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListSystemProviders>>
>;
export type GetV1ListSystemProvidersQueryError = unknown;

export function useGetV1ListSystemProviders<
  TData = Awaited<ReturnType<typeof getV1ListSystemProviders>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListSystemProviders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListSystemProviders>>,
          TError,
          Awaited<ReturnType<typeof getV1ListSystemProviders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListSystemProviders<
  TData = Awaited<ReturnType<typeof getV1ListSystemProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListSystemProviders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListSystemProviders>>,
          TError,
          Awaited<ReturnType<typeof getV1ListSystemProviders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListSystemProviders<
  TData = Awaited<ReturnType<typeof getV1ListSystemProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListSystemProviders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List System Providers
 */

export function useGetV1ListSystemProviders<
  TData = Awaited<ReturnType<typeof getV1ListSystemProviders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListSystemProviders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListSystemProvidersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List System Providers
 */
export const prefetchGetV1ListSystemProvidersQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListSystemProviders>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListSystemProviders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListSystemProvidersQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Webhook Ping
 */
export type postV1WebhookPingResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1WebhookPingResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1WebhookPingResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1WebhookPingResponseSuccess = postV1WebhookPingResponse200 & {
  headers: Headers;
};
export type postV1WebhookPingResponseError = (
  | postV1WebhookPingResponse401
  | postV1WebhookPingResponse422
) & {
  headers: Headers;
};

export type postV1WebhookPingResponse =
  | postV1WebhookPingResponseSuccess
  | postV1WebhookPingResponseError;

export const getPostV1WebhookPingUrl = (webhookId: string) => {
  return `/api/integrations/webhooks/${webhookId}/ping`;
};

export const postV1WebhookPing = async (
  webhookId: string,
  options?: RequestInit,
): Promise<postV1WebhookPingResponse> => {
  return customMutator<postV1WebhookPingResponse>(
    getPostV1WebhookPingUrl(webhookId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1WebhookPingMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1WebhookPing>>,
    TError,
    { webhookId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1WebhookPing>>,
  TError,
  { webhookId: string },
  TContext
> => {
  const mutationKey = ["postV1WebhookPing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1WebhookPing>>,
    { webhookId: string }
  > = (props) => {
    const { webhookId } = props ?? {};

    return postV1WebhookPing(webhookId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1WebhookPingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1WebhookPing>>
>;

export type PostV1WebhookPingMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Webhook Ping
 */
export const usePostV1WebhookPing = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1WebhookPing>>,
      TError,
      { webhookId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1WebhookPing>>,
  TError,
  { webhookId: string },
  TContext
> => {
  const mutationOptions = getPostV1WebhookPingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Exchange OAuth code for tokens
 */
export type postV1ExchangeOauthCodeForTokensResponse200 = {
  data: CredentialsMetaResponse;
  status: 200;
};

export type postV1ExchangeOauthCodeForTokensResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1ExchangeOauthCodeForTokensResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1ExchangeOauthCodeForTokensResponseSuccess =
  postV1ExchangeOauthCodeForTokensResponse200 & {
    headers: Headers;
  };
export type postV1ExchangeOauthCodeForTokensResponseError = (
  | postV1ExchangeOauthCodeForTokensResponse401
  | postV1ExchangeOauthCodeForTokensResponse422
) & {
  headers: Headers;
};

export type postV1ExchangeOauthCodeForTokensResponse =
  | postV1ExchangeOauthCodeForTokensResponseSuccess
  | postV1ExchangeOauthCodeForTokensResponseError;

export const getPostV1ExchangeOauthCodeForTokensUrl = (provider: string) => {
  return `/api/integrations/${provider}/callback`;
};

export const postV1ExchangeOauthCodeForTokens = async (
  provider: string,
  bodyPostV1ExchangeOauthCodeForTokens: BodyPostV1ExchangeOauthCodeForTokens,
  options?: RequestInit,
): Promise<postV1ExchangeOauthCodeForTokensResponse> => {
  return customMutator<postV1ExchangeOauthCodeForTokensResponse>(
    getPostV1ExchangeOauthCodeForTokensUrl(provider),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bodyPostV1ExchangeOauthCodeForTokens),
    },
  );
};

export const getPostV1ExchangeOauthCodeForTokensMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1ExchangeOauthCodeForTokens>>,
    TError,
    { provider: string; data: BodyPostV1ExchangeOauthCodeForTokens },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1ExchangeOauthCodeForTokens>>,
  TError,
  { provider: string; data: BodyPostV1ExchangeOauthCodeForTokens },
  TContext
> => {
  const mutationKey = ["postV1ExchangeOauthCodeForTokens"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1ExchangeOauthCodeForTokens>>,
    { provider: string; data: BodyPostV1ExchangeOauthCodeForTokens }
  > = (props) => {
    const { provider, data } = props ?? {};

    return postV1ExchangeOauthCodeForTokens(provider, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1ExchangeOauthCodeForTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1ExchangeOauthCodeForTokens>>
>;
export type PostV1ExchangeOauthCodeForTokensMutationBody =
  BodyPostV1ExchangeOauthCodeForTokens;
export type PostV1ExchangeOauthCodeForTokensMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Exchange OAuth code for tokens
 */
export const usePostV1ExchangeOauthCodeForTokens = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1ExchangeOauthCodeForTokens>>,
      TError,
      { provider: string; data: BodyPostV1ExchangeOauthCodeForTokens },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1ExchangeOauthCodeForTokens>>,
  TError,
  { provider: string; data: BodyPostV1ExchangeOauthCodeForTokens },
  TContext
> => {
  const mutationOptions =
    getPostV1ExchangeOauthCodeForTokensMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List Credentials By Provider
 */
export type getV1ListCredentialsByProviderResponse200 = {
  data: CredentialsMetaResponse[];
  status: 200;
};

export type getV1ListCredentialsByProviderResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListCredentialsByProviderResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1ListCredentialsByProviderResponseSuccess =
  getV1ListCredentialsByProviderResponse200 & {
    headers: Headers;
  };
export type getV1ListCredentialsByProviderResponseError = (
  | getV1ListCredentialsByProviderResponse401
  | getV1ListCredentialsByProviderResponse422
) & {
  headers: Headers;
};

export type getV1ListCredentialsByProviderResponse =
  | getV1ListCredentialsByProviderResponseSuccess
  | getV1ListCredentialsByProviderResponseError;

export const getGetV1ListCredentialsByProviderUrl = (provider: string) => {
  return `/api/integrations/${provider}/credentials`;
};

export const getV1ListCredentialsByProvider = async (
  provider: string,
  options?: RequestInit,
): Promise<getV1ListCredentialsByProviderResponse> => {
  return customMutator<getV1ListCredentialsByProviderResponse>(
    getGetV1ListCredentialsByProviderUrl(provider),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListCredentialsByProviderQueryKey = (
  provider?: string,
) => {
  return [`/api/integrations/${provider}/credentials`] as const;
};

export const getGetV1ListCredentialsByProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1ListCredentialsByProviderQueryKey(provider);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>
  > = ({ signal }) =>
    getV1ListCredentialsByProvider(provider, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!provider,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListCredentialsByProviderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>
>;
export type GetV1ListCredentialsByProviderQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1ListCredentialsByProvider<
  TData = Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
          TError,
          Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListCredentialsByProvider<
  TData = Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
          TError,
          Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListCredentialsByProvider<
  TData = Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Credentials By Provider
 */

export function useGetV1ListCredentialsByProvider<
  TData = Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListCredentialsByProviderQueryOptions(
    provider,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Credentials By Provider
 */
export const prefetchGetV1ListCredentialsByProviderQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  provider: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListCredentialsByProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListCredentialsByProviderQueryOptions(
    provider,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Credentials
 */
export type postV1CreateCredentialsResponse201 = {
  data: CredentialsMetaResponse;
  status: 201;
};

export type postV1CreateCredentialsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1CreateCredentialsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1CreateCredentialsResponseSuccess =
  postV1CreateCredentialsResponse201 & {
    headers: Headers;
  };
export type postV1CreateCredentialsResponseError = (
  | postV1CreateCredentialsResponse401
  | postV1CreateCredentialsResponse422
) & {
  headers: Headers;
};

export type postV1CreateCredentialsResponse =
  | postV1CreateCredentialsResponseSuccess
  | postV1CreateCredentialsResponseError;

export const getPostV1CreateCredentialsUrl = (provider: string) => {
  return `/api/integrations/${provider}/credentials`;
};

export const postV1CreateCredentials = async (
  provider: string,
  postV1CreateCredentialsBody: PostV1CreateCredentialsBody,
  options?: RequestInit,
): Promise<postV1CreateCredentialsResponse> => {
  return customMutator<postV1CreateCredentialsResponse>(
    getPostV1CreateCredentialsUrl(provider),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(postV1CreateCredentialsBody),
    },
  );
};

export const getPostV1CreateCredentialsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CreateCredentials>>,
    TError,
    { provider: string; data: PostV1CreateCredentialsBody },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CreateCredentials>>,
  TError,
  { provider: string; data: PostV1CreateCredentialsBody },
  TContext
> => {
  const mutationKey = ["postV1CreateCredentials"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CreateCredentials>>,
    { provider: string; data: PostV1CreateCredentialsBody }
  > = (props) => {
    const { provider, data } = props ?? {};

    return postV1CreateCredentials(provider, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CreateCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CreateCredentials>>
>;
export type PostV1CreateCredentialsMutationBody = PostV1CreateCredentialsBody;
export type PostV1CreateCredentialsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create Credentials
 */
export const usePostV1CreateCredentials = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CreateCredentials>>,
      TError,
      { provider: string; data: PostV1CreateCredentialsBody },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CreateCredentials>>,
  TError,
  { provider: string; data: PostV1CreateCredentialsBody },
  TContext
> => {
  const mutationOptions = getPostV1CreateCredentialsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Credentials
 */
export type deleteV1DeleteCredentialsResponse200 = {
  data: DeleteV1DeleteCredentials200;
  status: 200;
};

export type deleteV1DeleteCredentialsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV1DeleteCredentialsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV1DeleteCredentialsResponseSuccess =
  deleteV1DeleteCredentialsResponse200 & {
    headers: Headers;
  };
export type deleteV1DeleteCredentialsResponseError = (
  | deleteV1DeleteCredentialsResponse401
  | deleteV1DeleteCredentialsResponse422
) & {
  headers: Headers;
};

export type deleteV1DeleteCredentialsResponse =
  | deleteV1DeleteCredentialsResponseSuccess
  | deleteV1DeleteCredentialsResponseError;

export const getDeleteV1DeleteCredentialsUrl = (
  provider: string,
  credId: string,
  params?: DeleteV1DeleteCredentialsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/integrations/${provider}/credentials/${credId}?${stringifiedParams}`
    : `/api/integrations/${provider}/credentials/${credId}`;
};

export const deleteV1DeleteCredentials = async (
  provider: string,
  credId: string,
  params?: DeleteV1DeleteCredentialsParams,
  options?: RequestInit,
): Promise<deleteV1DeleteCredentialsResponse> => {
  return customMutator<deleteV1DeleteCredentialsResponse>(
    getDeleteV1DeleteCredentialsUrl(provider, credId, params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV1DeleteCredentialsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1DeleteCredentials>>,
    TError,
    {
      provider: string;
      credId: string;
      params?: DeleteV1DeleteCredentialsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1DeleteCredentials>>,
  TError,
  {
    provider: string;
    credId: string;
    params?: DeleteV1DeleteCredentialsParams;
  },
  TContext
> => {
  const mutationKey = ["deleteV1DeleteCredentials"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1DeleteCredentials>>,
    {
      provider: string;
      credId: string;
      params?: DeleteV1DeleteCredentialsParams;
    }
  > = (props) => {
    const { provider, credId, params } = props ?? {};

    return deleteV1DeleteCredentials(provider, credId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1DeleteCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1DeleteCredentials>>
>;

export type DeleteV1DeleteCredentialsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete Credentials
 */
export const useDeleteV1DeleteCredentials = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV1DeleteCredentials>>,
      TError,
      {
        provider: string;
        credId: string;
        params?: DeleteV1DeleteCredentialsParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1DeleteCredentials>>,
  TError,
  {
    provider: string;
    credId: string;
    params?: DeleteV1DeleteCredentialsParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteV1DeleteCredentialsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Specific Credential By ID
 */
export type getV1GetSpecificCredentialByIdResponse200 = {
  data: CredentialsMetaResponse;
  status: 200;
};

export type getV1GetSpecificCredentialByIdResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetSpecificCredentialByIdResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1GetSpecificCredentialByIdResponseSuccess =
  getV1GetSpecificCredentialByIdResponse200 & {
    headers: Headers;
  };
export type getV1GetSpecificCredentialByIdResponseError = (
  | getV1GetSpecificCredentialByIdResponse401
  | getV1GetSpecificCredentialByIdResponse422
) & {
  headers: Headers;
};

export type getV1GetSpecificCredentialByIdResponse =
  | getV1GetSpecificCredentialByIdResponseSuccess
  | getV1GetSpecificCredentialByIdResponseError;

export const getGetV1GetSpecificCredentialByIdUrl = (
  provider: string,
  credId: string,
) => {
  return `/api/integrations/${provider}/credentials/${credId}`;
};

export const getV1GetSpecificCredentialById = async (
  provider: string,
  credId: string,
  options?: RequestInit,
): Promise<getV1GetSpecificCredentialByIdResponse> => {
  return customMutator<getV1GetSpecificCredentialByIdResponse>(
    getGetV1GetSpecificCredentialByIdUrl(provider, credId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetSpecificCredentialByIdQueryKey = (
  provider?: string,
  credId?: string,
) => {
  return [`/api/integrations/${provider}/credentials/${credId}`] as const;
};

export const getGetV1GetSpecificCredentialByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  credId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1GetSpecificCredentialByIdQueryKey(provider, credId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>
  > = ({ signal }) =>
    getV1GetSpecificCredentialById(provider, credId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(provider && credId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetSpecificCredentialByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>
>;
export type GetV1GetSpecificCredentialByIdQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1GetSpecificCredentialById<
  TData = Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  credId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
          TError,
          Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetSpecificCredentialById<
  TData = Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  credId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
          TError,
          Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetSpecificCredentialById<
  TData = Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  credId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Specific Credential By ID
 */

export function useGetV1GetSpecificCredentialById<
  TData = Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  credId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetSpecificCredentialByIdQueryOptions(
    provider,
    credId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Specific Credential By ID
 */
export const prefetchGetV1GetSpecificCredentialByIdQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  provider: string,
  credId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificCredentialById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetSpecificCredentialByIdQueryOptions(
    provider,
    credId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * Return the raw access token for an OAuth2 credential so the frontend
can initialize a provider-hosted picker (e.g. Google Drive Picker).

`GET /{provider}/credentials/{cred_id}` deliberately strips secrets (see
`CredentialsMetaResponse` + `TestGetCredentialReturnsMetaOnly` in
`router_test.py`). That hardening broke the Drive picker, which needs the
raw access token to call `google.picker.Builder.setOAuthToken(...)`. This
endpoint carves a narrow, explicit hole: the caller must own the
credential, it must be OAuth2, and the endpoint returns only the access
token + its expiry — nothing else about the credential. SDK-default
credentials are excluded for the same reason as `get_credential`.
 * @summary Issue a short-lived access token for a provider-hosted picker
 */
export type postV1GetPickerTokenResponse200 = {
  data: PickerTokenResponse;
  status: 200;
};

export type postV1GetPickerTokenResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1GetPickerTokenResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1GetPickerTokenResponseSuccess =
  postV1GetPickerTokenResponse200 & {
    headers: Headers;
  };
export type postV1GetPickerTokenResponseError = (
  | postV1GetPickerTokenResponse401
  | postV1GetPickerTokenResponse422
) & {
  headers: Headers;
};

export type postV1GetPickerTokenResponse =
  | postV1GetPickerTokenResponseSuccess
  | postV1GetPickerTokenResponseError;

export const getPostV1GetPickerTokenUrl = (
  provider: string,
  credId: string,
) => {
  return `/api/integrations/${provider}/credentials/${credId}/picker-token`;
};

export const postV1GetPickerToken = async (
  provider: string,
  credId: string,
  options?: RequestInit,
): Promise<postV1GetPickerTokenResponse> => {
  return customMutator<postV1GetPickerTokenResponse>(
    getPostV1GetPickerTokenUrl(provider, credId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1GetPickerTokenMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1GetPickerToken>>,
    TError,
    { provider: string; credId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1GetPickerToken>>,
  TError,
  { provider: string; credId: string },
  TContext
> => {
  const mutationKey = ["postV1GetPickerToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1GetPickerToken>>,
    { provider: string; credId: string }
  > = (props) => {
    const { provider, credId } = props ?? {};

    return postV1GetPickerToken(provider, credId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1GetPickerTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1GetPickerToken>>
>;

export type PostV1GetPickerTokenMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Issue a short-lived access token for a provider-hosted picker
 */
export const usePostV1GetPickerToken = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1GetPickerToken>>,
      TError,
      { provider: string; credId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1GetPickerToken>>,
  TError,
  { provider: string; credId: string },
  TContext
> => {
  const mutationOptions = getPostV1GetPickerTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Initiate OAuth flow
 */
export type getV1InitiateOauthFlowResponse200 = {
  data: LoginResponse;
  status: 200;
};

export type getV1InitiateOauthFlowResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1InitiateOauthFlowResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1InitiateOauthFlowResponseSuccess =
  getV1InitiateOauthFlowResponse200 & {
    headers: Headers;
  };
export type getV1InitiateOauthFlowResponseError = (
  | getV1InitiateOauthFlowResponse401
  | getV1InitiateOauthFlowResponse422
) & {
  headers: Headers;
};

export type getV1InitiateOauthFlowResponse =
  | getV1InitiateOauthFlowResponseSuccess
  | getV1InitiateOauthFlowResponseError;

export const getGetV1InitiateOauthFlowUrl = (
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/integrations/${provider}/login?${stringifiedParams}`
    : `/api/integrations/${provider}/login`;
};

export const getV1InitiateOauthFlow = async (
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
  options?: RequestInit,
): Promise<getV1InitiateOauthFlowResponse> => {
  return customMutator<getV1InitiateOauthFlowResponse>(
    getGetV1InitiateOauthFlowUrl(provider, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1InitiateOauthFlowQueryKey = (
  provider?: string,
  params?: GetV1InitiateOauthFlowParams,
) => {
  return [
    `/api/integrations/${provider}/login`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1InitiateOauthFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1InitiateOauthFlowQueryKey(provider, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1InitiateOauthFlow>>
  > = ({ signal }) =>
    getV1InitiateOauthFlow(provider, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!provider,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1InitiateOauthFlowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1InitiateOauthFlow>>
>;
export type GetV1InitiateOauthFlowQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1InitiateOauthFlow<
  TData = Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  params: undefined | GetV1InitiateOauthFlowParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
          TError,
          Awaited<ReturnType<typeof getV1InitiateOauthFlow>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1InitiateOauthFlow<
  TData = Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
          TError,
          Awaited<ReturnType<typeof getV1InitiateOauthFlow>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1InitiateOauthFlow<
  TData = Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Initiate OAuth flow
 */

export function useGetV1InitiateOauthFlow<
  TData = Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1InitiateOauthFlowQueryOptions(
    provider,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Initiate OAuth flow
 */
export const prefetchGetV1InitiateOauthFlowQuery = async <
  TData = Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  provider: string,
  params?: GetV1InitiateOauthFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1InitiateOauthFlow>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1InitiateOauthFlowQueryOptions(
    provider,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Webhook Ingress Generic
 */
export type postV1WebhookIngressGenericResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1WebhookIngressGenericResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1WebhookIngressGenericResponseSuccess =
  postV1WebhookIngressGenericResponse200 & {
    headers: Headers;
  };
export type postV1WebhookIngressGenericResponseError =
  postV1WebhookIngressGenericResponse422 & {
    headers: Headers;
  };

export type postV1WebhookIngressGenericResponse =
  | postV1WebhookIngressGenericResponseSuccess
  | postV1WebhookIngressGenericResponseError;

export const getPostV1WebhookIngressGenericUrl = (
  provider: string,
  webhookId: string,
) => {
  return `/api/integrations/${provider}/webhooks/${webhookId}/ingress`;
};

export const postV1WebhookIngressGeneric = async (
  provider: string,
  webhookId: string,
  options?: RequestInit,
): Promise<postV1WebhookIngressGenericResponse> => {
  return customMutator<postV1WebhookIngressGenericResponse>(
    getPostV1WebhookIngressGenericUrl(provider, webhookId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1WebhookIngressGenericMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1WebhookIngressGeneric>>,
    TError,
    { provider: string; webhookId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1WebhookIngressGeneric>>,
  TError,
  { provider: string; webhookId: string },
  TContext
> => {
  const mutationKey = ["postV1WebhookIngressGeneric"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1WebhookIngressGeneric>>,
    { provider: string; webhookId: string }
  > = (props) => {
    const { provider, webhookId } = props ?? {};

    return postV1WebhookIngressGeneric(provider, webhookId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1WebhookIngressGenericMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1WebhookIngressGeneric>>
>;

export type PostV1WebhookIngressGenericMutationError = HTTPValidationError;

/**
 * @summary Webhook Ingress Generic
 */
export const usePostV1WebhookIngressGeneric = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1WebhookIngressGeneric>>,
      TError,
      { provider: string; webhookId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1WebhookIngressGeneric>>,
  TError,
  { provider: string; webhookId: string },
  TContext
> => {
  const mutationOptions =
    getPostV1WebhookIngressGenericMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
